import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  UpdatePubSecExperienceMutation,
  UpdatePubSecExperienceMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const updatePubSecExperienceDocument = graphql(`
  mutation updatePubSecExperience($pubSecExperience: String) {
    updatePubSecExperience(pubSecExperience: $pubSecExperience) {
      success
    }
  }
`);

export function useUpdatePubSecExperience(
  options?: UseMutationOptions<
    UpdatePubSecExperienceMutation,
    unknown,
    UpdatePubSecExperienceMutationVariables,
    unknown
  >,
) {
  return useGraphQlMutation(updatePubSecExperienceDocument, options);
}
